import { useCallback, useState } from 'react';
import { PhoenixGridHeader } from '@modules/admin/Tools/LenderUtility/shared/PhoenixGridHeader';
import { Wrapper } from '@styles/CommonStyles';
import OutOfSyncGrid from './OutOfSyncGrid';
import OutOfSyncForm from './OutOfSyncForm';
import { outOfSyncDS, outOfSyncDSAdjustment } from './constatnts';
import { requestOutOfSyncData } from './requests';

interface IDealsheetAdj {
  id: string;
  dealId: string;
  customerName: string;
  createdDate: string;
  amountFinanced: number;
  adjPayOff: number;
  totalAdjustment: number;
  isSyncedToAcumatica: string;
}

interface IDealsheet {
  id: string;
  dealId: string;
  fundedDate: string | null;
  amount: number;
  customerName: string;
  createdDate: string;
  isSyncedToAcumatica: string;
}

interface IDealsheetDataProps {
  dealsheetData: IDealsheet[];
  dealsheetAdjData: IDealsheetAdj[];
}

const OutOfSyncDS = () => {
  const [dSData, setDSData] = useState<IDealsheetDataProps>({
    dealsheetData: [],
    dealsheetAdjData: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSearchBtn = useCallback(async(_startDate: string | null, _endDate: string | null) => {
    setIsLoading(true);
    const syncData = await requestOutOfSyncData(_startDate, _endDate, 'dealsheets');
    const syncAdjustData = await requestOutOfSyncData(_startDate, _endDate, 'dealsheetadjustments');
    const data = {
      dealsheetData: syncData,
      dealsheetAdjData: syncAdjustData,
    };
    setDSData(data);
    setIsLoading(false);
  }, []);

  return (
    <>
      <Wrapper>
        <PhoenixGridHeader title="Out Of Sync Dealsheets" />
        <OutOfSyncForm handleSearchBtn={handleSearchBtn} isLoading={isLoading} />
        <OutOfSyncGrid gridData={dSData?.dealsheetData} config={outOfSyncDS} />
        <OutOfSyncGrid gridData={dSData?.dealsheetAdjData} config={outOfSyncDSAdjustment} title="Out Of Sync Dealsheet Adjustment" />
      </Wrapper>
    </>
  );
};

export default OutOfSyncDS;
